import { render } from "./StepFive.vue?vue&type=template&id=0bf499d2&scoped=true&ts=true"
import script from "./StepFive.vue?vue&type=script&lang=ts"
export * from "./StepFive.vue?vue&type=script&lang=ts"

import "./StepFive.vue?vue&type=style&index=0&id=0bf499d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf499d2"]])

export default __exports__